export default __webpack_public_path__ + "static/tr-fdff83487f542e0dc657973b5a628127.svg";